import { MFile, MInput, MLabel, ValidatedForm } from "components/forms";
import { dateHelper, payloadBuilder } from "libs";
import React from "react";

export class AbilitazioneTitoloEstero extends ValidatedForm {
  emptyFields = {
    istitution: "",
    nation: "",
    address: "",
    cap: "",
    houseNumber: "",
    dataConseguimento: "",
    contactName: "",
    contactPhone: "",
    contactFax: "",
    contactEmail: "",
    contactPec: "",
  };

  FIELDS_GROUP = [
    [
      {
        id: "abilitazioneLabel",
        field: "abilitazioneLabel",
        infoText:
          "Conseguimento, presso un'università estera legalmente accreditata nel paese di origine, o altro organismo abilitato all'interno dello stesso, di un percorso formativo sul sostegno agli alunni con disabilità, svolto prevalentemente su territorio dell'UE, con durata non inferiore a 1.500 ore o, in alternativa, idoneo al conseguimento di almeno 60 CFU.",
        component: MLabel,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Ateneo o organismo abilitato all'estero",
        component: MInput,
        type: "text",
        className: "col-md-8",
      },
      {
        id: "nation",
        field: "nation",
        label: "Paese estero",
        component: MInput,
        type: "text",
        className: "col-md-4",
      },
    ],
    [
      {
        field: "address",
        label: "Indirizzo",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        field: "cap",
        label: "CAP",
        component: MInput,
        type: "text",
        className: "col-md-3",
      },
      {
        field: "houseNumber",
        label: "Num. civico",
        component: MInput,
        type: "text",
        className: "col-md-3",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento",
        component: MInput,
        type: "date",
        className: "col-md-4 pt-3",
      },
    ],
    [
      {
        field: "titoloEsteroLabel",
        label: "Titolo di abilitazione o di specializzazione sul sostegno conseguito all'estero",
        component: MLabel,
        className: "col-md-12 pt-2 pb-0 mb-0",
      },
      {
        id: "titoloEsteroFile",
        field: "document",
        component: MFile,
        value: this.props.enrollmentId,
        config: {
          endPoint: "/enrollment/attachment-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "abilitazioneEstero",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "optionalInfo",
        label: "Informazioni facoltative:",
        infoText:
          "Informazioni per la verifica dei dati ex articolo 15, comma 1, punto e della legge 183/2011. Recapiti della segreteria competente.",
        component: MLabel,
        className: "col-md-12",
      },
    ],
    [
      {
        field: "contactName",
        label: "Denominazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        field: "contactPhone",
        label: "Telefono",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        field: "contactFax",
        label: "Fax",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        field: "contactEmail",
        label: "Email",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        field: "contactPec",
        label: "Pec",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
  ];

  ERROR_MESSAGES = {
    istitution: "Dato obbligatorio",
    nation: "Dato obbligatorio",
    address: "Dato obbligatorio",
    cap: "Dato obbligatorio",
    houseNumber: "Dato obbligatorio",
    dataConseguimento: "Dato obbligatorio",
  };

  validation = {
    istitution: (value) => value !== "",
    nation: (value) => value !== "",
    address: (value) => value !== "",
    cap: (value) => value !== "",
    houseNumber: (value) => value !== "",
    dataConseguimento: (value) => this.validateDataConseguimento(value),
  };

  validateDataConseguimento = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const noFuture = dateHelper.noFuture(value);
    if (noFuture === false) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 70 || year > currentYear) {
      return false;
    }

    return true;
  };

  state = {
    ...this.emptyFields,
    defaultValues: { ...this.emptyFields },
  };

  componentDidMount() {
    const { defaultPayload, enrollmentId } = this.props;

    if (defaultPayload && defaultPayload.length > 0) {
      const abilitazione = defaultPayload[0];
      this.setState({
        ...abilitazione,
        document: enrollmentId,
        defaultValues: { ...abilitazione },
      });
    } else {
      this.setState({
        document: enrollmentId,
        defaultValues: { ...this.state.defaultValues },
      });
    }
  }

  getPayload = () => {
    this.payload = payloadBuilder(this.state);
    this.payload.qualificationType = "AbilitazioneEstero";
    this.payload.extCode = "Title14_AbilitazioneEstero";
    this.payload.qualificationCode = "title14";
    this.payload.template = "Title14_AbilitazioneEstero";

    return this.payload;
  };

  onSubmit = () => {
    const isValid = this.checkValidation();
    return isValid;
  };

  constructor(props) {
    super(props);
    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  //--- ---
  render() {
    const { defaultValues } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return <form className="user mt-3">{code}</form>;
  }
}
